var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NameTest"},[_c('MultipleChoiceInputGrid',{ref:"input",attrs:{"items":_vm.data.fragments,"selections":_vm.selectedFragmentIndices},on:{"item-click":_vm.handleItemClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }